import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCanGoBack } from "./useCanGoBack";
import { useTelegram } from "../contexts/TelegramContext";

export function useTelegramBackButton() {
  const navigate = useNavigate();
  const canGoBack = useCanGoBack();
  const { isTelegram, tg } = useTelegram();

  useEffect(() => {
    if (!isTelegram || !tg) return;

    if (canGoBack) {
      tg.BackButton.show();
    } else {
      tg.BackButton.hide();
    }
  }, [canGoBack, isTelegram, tg]);

  useEffect(() => {
    if (!isTelegram || !tg) return;

    const handler = () => {
      navigate(-1);
    };

    tg.BackButton.onClick(handler);
    return () => tg.BackButton.offClick(handler);
  }, [isTelegram, tg, navigate]);
}
